import { Request, config } from '@blofin/blofin-http';
import { baseUrl, gatewayUrl, demoUrl } from './base';

const httpRequest = new Request({
  config,
  baseUrl,
  gatewayUrl,
  demoTradingUrl: demoUrl,
});

export default httpRequest;
